export const CONFIGURATION = {
    URLS: {
        DOCUMENT: '/files/documents',
        KEY_CHARACTERISTICS: '/files/keyCharacteristics'
    }
}